import { DistributionDividendPreference } from "../../../../Wrap/Constants/Enums/Domain/DistributionDividendPreference";
import { DividendReinvestment } from "../../../../Wrap/Constants/Enums/Domain/DividendReinvestment";
import { SubAccountType } from "../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { InvestmentType } from "../../../../Wrap/Constants/Enums/InvestmentType";
import { PensionPathwayInvestmentOption } from "../../../../Wrap/Constants/Enums/PensionPathwayInvestmentOption";
import { BatchType } from "../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { ServiceProposition } from "../../../../Wrap/Constants/Enums/ServiceProposition";
import { AllocationTableItem } from "../Store/SelectedInvesmentStoreStatic";

export enum ProcessType {
    NB = "new business",
    Quote = "quote",
    SinglePayment = "add single payment(including re-reg)",
    AddRegular = "add regular",
    EditRegular = "edit Regular",
    Buy = "buy",
    Sell = "sell",
    SwitchTo = "switch to",
    SwitchFrom = "switch from",
    BedAndProduct = "bed & product",
    Switch = "switch",
    TakePensionBenefits = "take pension benefits",
    TopUpWithITFLS = "Top-up with immediate Tax-free lump sum",
    EditIncome = "edit income",
    NBEC = "add product",
    GadReview = "gad review",
    WhatIf = "what if",
    Withdrawal = "withdrawal",
    NoChange = "no change",
    MoveAssetsToNewOwner = "move assets to new owner",
    EditIncomeDrawdown = "edit income drawdown",
    PPToProduct = "pp to product",
    CancelRegularCrystallisation = "Cancel Regular Crystallisation",
    OneoffIncomePayments = "One-off Income Payments",
    ConvertCappedToFlexi = "Convert Capped To Flexi",
    

}

export enum investmentType {
    HubPortfolios = "Managed portfolios",
    AdviserPortfolios = "Adviser portfolios",
    Funds = "Funds",
    ExchangeTraded = "Exchange traded",
    OffPlatform = "Off-platform",
    CashDeposits = "Cash deposits",
}

export const distributionDividendPreferenceMap = {
    [DistributionDividendPreference.Reinvest]: "Reinvest",
    [DistributionDividendPreference.ProductCash]: "Leave as cash in ISA / PP",
    [DistributionDividendPreference.WrapCash]: "Leave as cash in Cash Account",
    [DistributionDividendPreference.BankAccount]: "Transfer to a nominated Bank Account",
};

export const InvestmentTypeMap = {
    [InvestmentType.HubPortfolios]: "Managed portfolios",
    [InvestmentType.AdviserPortfolios]: "Adviser portfolios",
    [InvestmentType.Funds]: "Funds",
    [InvestmentType.ExchangeTraded]: "Exchange traded",
    [InvestmentType.OffPlatform]: "Off-platform",
    [InvestmentType.CashDeposits]: "Cash deposits",
};

export const manageIncomeOptionsMap = {
    [DistributionDividendPreference.Reinvest]: "Reinvest",
    [DistributionDividendPreference.ProductCash]: "Leave as cash in Aberdeen SIPP",
};

export enum reuseType {
    no = "No",
    useTargetAllocation = "Use target allocation",
    useCurrentAssets = "Use current assets",
}

export const PensionPathwayInvestmentOptionBuySellSwitchArray = [
    PensionPathwayInvestmentOption.InvestmentPathway,
    PensionPathwayInvestmentOption.SelectInvestments,
];

export const PensionPathwayInvestmentOptionArrayBuySellSwitchMap = {
    [PensionPathwayInvestmentOption.InvestmentPathway]: "Use investment pathways",
    [PensionPathwayInvestmentOption.SelectInvestments]: "Select investments without using investment pathways",
};

export enum InvestmentPathOptions {
    NotSpecified = 0,
    NoPlan = 1,
    GuaranteeIncome = 2,
    LongTermIncome = 3,
    Takeout = 4,
}

export const investmentPathOptionsArray = [
    InvestmentPathOptions.NotSpecified,
    InvestmentPathOptions.NoPlan,
    InvestmentPathOptions.GuaranteeIncome,
    InvestmentPathOptions.LongTermIncome,
    InvestmentPathOptions.Takeout,
];

export const investmentPathOptionsMap = {
    [InvestmentPathOptions.NotSpecified]: "-- please select --",
    [InvestmentPathOptions.NoPlan]: "No plans to touch their money in the next 5 years",
    [InvestmentPathOptions.GuaranteeIncome]:
        "Plans to use their money to set up a guaranteed income (annuity) within the next 5 years",
    [InvestmentPathOptions.LongTermIncome]:
        "Plans to start taking their money as a long-term income within the next 5 years",
    [InvestmentPathOptions.Takeout]: "Plan to take out all their money within the next 5 years",
};

export const FundType = {
    [DividendReinvestment.Accumulation]: "Accumulation",
    [DividendReinvestment.Income]: "Income",
};

export const reuseTooltip =
    "Selecting Use Target Allocation, will input the clients current target allocation into the IST section, with percentage allocation against each instrument. \n Selecting Use Current Assets, will input the clients current instrument holdings into the IST table, without percentage allocation against each instrument.";

export const targetAllocationAlert =
    "Any investments you select here will not update the target allocation. If you want to update this, you can do this on the Target Allocation page.";

export const leiCodevalidationMessage = "The LEI code for this company does not exist.";

export interface ISearchProps {
    hiercharyId: string;
    type: SubAccountType;
    tableData?: AllocationTableItem[];
    index?: number;
    researchIst?: boolean;
    accountServiceProposition?: ServiceProposition;
    canBeBought?: boolean;
    canBeSold?: boolean;
    includeInsuredFund?: boolean;
    CanBeTransferred?: boolean;
    batchType?: BatchType;
    TailoredDrawdownAllowed?: boolean;
    selectedPathwayText?: string;
}

const reuseProcess = [
    ProcessType.Buy,
    ProcessType.AddRegular,
    ProcessType.SinglePayment,
    ProcessType.TopUpWithITFLS,
    ProcessType.SwitchTo,
    ProcessType.EditRegular,
    ProcessType.BedAndProduct,
    ProcessType.WhatIf,
];
export const reuseShowCondition = (processType: ProcessType) => {
    return reuseProcess.includes(processType);
};

const useSameInvestmentAsPerProductProcess = [ProcessType.NB, ProcessType.Quote];
const useSameInvestmentAsPerProductProduct = [SubAccountType.StocksIsa, SubAccountType.InvestmentAccount];
export const useSameInvestmentAsPerProductShowCondition = (
    processType: ProcessType,
    productType: SubAccountType
): boolean => {
    return (
        useSameInvestmentAsPerProductProcess.includes(processType) &&
        useSameInvestmentAsPerProductProduct.includes(productType)
    );
};

const manageIncomeProduct = [SubAccountType.Sipp, SubAccountType.Npr, SubAccountType.JuniorSipp];
export const manageIncomeShowCondition = (processType: ProcessType, productType: SubAccountType): boolean => {
    return distributionOptionsProcess.includes(processType) && manageIncomeProduct.includes(productType);
};

export const distributionOptionsProcess = [ProcessType.NB, ProcessType.Quote, ProcessType.SinglePayment, ProcessType.AddRegular, ProcessType.EditRegular];
const distributionOptionsProduct = [SubAccountType.StocksIsa, SubAccountType.InvestmentAccount];
export const distributionOptionsShowCondition = (processType: ProcessType, productType: SubAccountType): boolean => {
    return distributionOptionsProcess.includes(processType) && distributionOptionsProduct.includes(productType);
};

export const allocationInfoTextShowConditon = [ProcessType.NB, ProcessType.SinglePayment];
export const distributionOptionSubHeader = "Please select from one of the following manage income options:";

export const GBPInvestmentCode = "GBPCash";

export const OffPlatformAssetBuyReminderMessage = "Ensure sufficient funds are held in Product cash to cover the charges incurred by this investment type.";
